<div class="fpx-form-control">
    <fpx-label *ngIf="label" [control]="formControl" [label]="label"></fpx-label>
    <div class="fpx-field-content otp-input-field">
        <input #otpField type="rel" inputmode="numeric" matInput [ngClass]="{
            error: formControl && formControl.invalid && formControl.touched
          }" name="new-password" autocomplete="off" type="password" inputmode="numeric"
          [minlength]="size" [maxlength]="size" [formControl]="formControl" 
          (click)="onClick($event)" autofocus />
    
        <div class="otp-display">
            <ng-container *ngFor="let ind of counter(size); let i = index">
                <span [ngClass]="{'un-mask-pin': unMaskPin, 'active' : formControl.value?.charAt(i) }" class="otp-input">
                  {{ formControl.value?.charAt(i) || ''}}
                </span>
            </ng-container>
        </div>
        <mat-error *ngIf="formControl && formControl.invalid && formControl.touched">
            {{ errorCode }}
        </mat-error>
    </div>
</div>

<ng-container *ngIf="showPinOption">
    <div class="show-mpin-link"><span (click)="showMpin()">
        <span *ngIf="!unMaskPin; else hidePIN">Show PIN</span>
        <ng-template #hidePIN><span>Hide PIN</span></ng-template>
    </span></div>
</ng-container>
